// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2020." + {"50":"adb94523d408878005bc","160":"1c59b42d7707714729a5","502":"df1da0a72f1d1b9cab2a","968":"d42bb35b2e517f4a45d8"}[chunkId] + ".js";
};